module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alarm"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-flex', {
    attrs: {
      "text-xs-left": "",
      "pl-3": ""
    }
  }, [_c('p', [_vm._v("Buscar")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "search pb-3"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Escriba su nombre o apellido / empresa"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "search-btn"
  }, [_vm._v("Buscar")])], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "text-xs-left": "",
      "md6": "",
      "mr-5": "",
      "xs12": ""
    }
  }, [_c('p', [_vm._v("Completa los datos")]), _vm._v(" "), _c('p', [_vm._v("Huésped")]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("Ariel Esteban Puga Ogalde")]), _vm._v(" "), _c('div', {
    staticClass: "check-info"
  }, [_c('div', {
    staticClass: "check-in"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Check in")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "check-out"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Check out")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "observation pl-2 mt-5"
  }, [_c('p', [_vm._v("Observacióon")]), _vm._v(" "), _c('textarea', {
    attrs: {
      "name": "",
      "id": "",
      "cols": "30",
      "rows": "10",
      "placeholder": "Escribe alguna observación"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "observation-button"
  }, [_vm._v("Guardar")])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "row": "",
      "wrap": "",
      "md5": "",
      "xs12": "",
      "pt-5": ""
    }
  }, [_c('div', {
    staticClass: "time-picker"
  }, [_c('div', {
    staticClass: "alarm-time"
  }, [_c('span', {
    staticClass: "pr-3"
  }, [_vm._v("Hora de la llamada")]), _vm._v(" "), _c('button', {
    staticClass: "btn-timer"
  }, [_vm._v("a.m.")]), _vm._v(" "), _c('button', {
    staticClass: "btn-timer"
  }, [_vm._v("p.m.")])]), _vm._v(" "), _c('div', {
    staticClass: "watch"
  }), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_c('span', [_vm._v("1:13 A.M.")])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-316319fd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/alarm/List.vue
// module id = 1612
// module chunks = 79